import React from 'react';
import PropTypes from 'prop-types';

import HelpArticleLink from '../../components/help-article-link';
import { InsuranceProviders } from '../../enums/insurance-providers';
import { ChildrenPropType } from '../../prop-types/children';
import { linkIDs } from '../../services/link-service/links';

const helpArticleIdMap = {
  [InsuranceProviders.Shipsurance.insuranceProviderId]: linkIDs.ShipsuranceKB,
  [InsuranceProviders.XCover.insuranceProviderId]: linkIDs.XCoverKB,
  [InsuranceProviders.ParcelGuard.insuranceProviderId]: linkIDs.ParcelGuardKB,
};

export const InsuranceKBLink = ({ insuranceProviderId, children }) => {
  return <HelpArticleLink articleId={helpArticleIdMap[insuranceProviderId]}>{children}</HelpArticleLink>;
};

InsuranceKBLink.propTypes = {
  insuranceProviderId: PropTypes.string.isRequired,
  children: ChildrenPropType.isRequired,
};
